















import Vue from "vue";
import VueLoadImage from "vue-load-image";

export default Vue.extend({
  components: {
    "vue-load-image": VueLoadImage
  },

  props: {
    breedId: String
  },

  computed: {
    url() {
      return this.$store.state.catImages[this.breedId];
    }
  },

  mounted() {
    if (!this.breedId) {
      return;
    }
    this.$store.dispatch("loadImage", {
      breedId: this.breedId
    });
  },
  watch: {
    breedId() {
      this.$store.dispatch("loadImage", {
        breedId: this.breedId
      });
    }
  }
});
